import
{
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Bar } from 'react-chartjs-2';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faBarChart } from '@fortawesome/free-solid-svg-icons';

const Especies = ({ labels, data: especies }) =>
{
    ChartJS.register
    (
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
    );

    const options =
    {
        maintainAspectRatio: false,
        responsive: true,
        elements:
        {
            bar:
            {
                borderRadius: 10,
                borderWidth: 1.5,
                borderColor: 'rgb(53, 162, 235)',
            },
        },
        plugins:
        {
            legend:
            {
                display: true,
                position: 'bottom',
                labels:
                {
                    boxWidth: 12,
                    padding: 14,
                    color: '#343a40',
                },
            },
            title:
            {
                display: false,
            },
            tooltip:
            {
                callbacks:
                {
                    label: function (context)
                    {
                        let label = context.dataset.label || '';
                        if (label) { label += ': '; }
                        if (context.parsed.y !== null) { label += context.parsed.y.toLocaleString('es-CL'); }
                        return label;
                    },
                },
            },
        },
        scales:
        {
            y:
            {
                beginAtZero: true,
                grid:
                {
                    color: 'rgba(100, 100, 100, 0.08)',
                },
                ticks:
                {
                    callback: function (value)
                    {
                        return value.toLocaleString('es-CL');
                    },
                    color: '#343a40',
                },
            },
            x:
            {
                ticks:
                {
                    color: '#343a40',
                },
                grid:
                {
                    color: 'rgba(100, 100, 100, 0.08)',
                },
            },
        },
    };

    const data =
    {
        labels: labels,
        datasets:
        [
            {
                label: 'Núm. Archivos',
                data: especies,
                backgroundColor: 'rgba(53, 162, 235, 0.45)',
                borderRadius: 10,
            },
        ],
    };

    return (
        <div className="card border rounded-5 shadow-sm mb-4">
            <div className="card-header rounded-top-5 bg-white border-bottom py-3 d-flex align-items-center gap-2">
                <FontAwesomeIcon className="text-primary" icon={faBarChart} />
                {'Gráfico de Especies'}
            </div>
            <div className="card-body p-3" style={{ minHeight: '300px' }}><Bar options={options} data={data} /></div>
        </div>
    );
}

export default Especies;
